import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import Button from "../formfields/Button"
import { GlobalContext } from "../GlobalContext"
import Card from "../ui-elements/Card"
import Spinner from "../ui-elements/Spinner"
import { subscribe } from "../utils/pubsub"


type Props = {
    assetTypeId: string,
    checklistId: string
}

function AssetPicker(
    { assetTypeId, checklistId }: Props
) {

    const navigate = useNavigate()

    const startAssetChecklistFromPicker = (assetId: string) => {
        setShowModal({ "spinner": 'Saving...' })
        const payload = JSON.stringify({
            action: "checklistsClientApp",
            subAction: "startAdhocChecklist",
            checklistId: checklistId,
            assetId: assetId,
        })

        // when table data is updated with a check period for this checklist,
        // navigate to the checklist
        const unsubscribe = subscribe("tableUpdateItemAdded", data => {
            if (
                data.tableName === 'ChecklistPeriods' &&
                data.newRecord &&
                data.newRecord.Id &&
                data.newRecord.ChecklistId === checklistId
            ) {
                setShowModal(null)
                navigate(`/checklists/${data.newRecord.Id}`)
                unsubscribe()
            }
        })
        sendMessageToWebsocket(payload)
    }

    const {
        tableData,
        setShowModal,
        sendMessageToWebsocket,
        t
    } = useContext(GlobalContext)





    let assets_of_type: any = {}

    if (tableData['Assets']) {
        for (const [asset_id, asset_details] of Object.entries(tableData['Assets'])) {
            //@ts-ignore
            if (asset_details['AssetTypeId'] as string == assetTypeId) {
                assets_of_type[asset_id] = asset_details
            }
        }
    }

    const any_assets = tableData['Assets'] && Object.keys(tableData['Assets']).length > 0

    return <>
        {!any_assets && <Spinner><p>{t('Dashboard.AssetPicker.loadingAssets')}</p></Spinner>}
        {any_assets && <>{t('Dashboard.AssetPicker.chooseAsset')}
            {
                <ul>
                    {Object.entries(assets_of_type).map(([assetId, assetDetails]: [string, any]) => (
                        <p key={assetId}>
                            <Button
                                onClick={() => { startAssetChecklistFromPicker(assetId) }}
                                text={assetDetails['AssetName']}
                                size={'big'}
                                variant={`primary`}
                                id={assetDetails['AssetName']}
                            /> &nbsp;
                        </p>
                    ))}
                </ul>
            }
        </>}
    </>
}
export default AssetPicker